export default __webpack_public_path__ + "static/media/cover-bg.03306c2d.jpg";